import { render } from "./itemTicket.vue?vue&type=template&id=4bc090bb"
import script from "./itemTicket.vue?vue&type=script&lang=js"
export * from "./itemTicket.vue?vue&type=script&lang=js"

import "./itemTicket.vue?vue&type=style&index=0&id=4bc090bb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__